import { useData } from 'vike-react/useData';
import type { Data } from './+data';
import { PillarPageRenderer } from '../../components/layout/PillarPageRenderer';

export default function ComparateurPage() {
  const { page } = useData<Data>();
  return (
    <PillarPageRenderer
      page={page}
      pillarLabel="Comparateur d'énergie"
      pillarDescription="Courtier indépendant des fournisseurs d'énergie pour professionnels et entreprises : comparez toutes les offres électricité et gaz, sans partenariat exclusif."
      pillarUrl="https://solutionecofrance.fr/comparateur"
    />
  );
}
